import { Button } from "@clockwise/design-system";
import { fg_default } from "@clockwise/design-system/tokens";
import { Skeleton } from "@material-ui/lab";
import classNames from "classnames";
import { CalendarCheck } from "phosphor-react";
import React from "react";

type Props = {
  disabled?: boolean;
  emphisis?: boolean;
  loading?: boolean;
  onConfirm?: () => void;
  onHover?: (isPreviwed: boolean) => void;
  onSelect?: () => void;
  state?: "default" | "selected" | "confirming";
  text?: string;
};

export const QuickRescheduleOption = ({
  disabled = false,
  emphisis = false,
  loading = false,
  onConfirm,
  onHover,
  onSelect,
  state = "default",
  text = "",
}: Props) => {
  const defaultState = state === "default";
  const selectedState = state === "selected";
  const confirmingState = state === "confirming";

  const handleConfirm = (event: React.MouseEvent) => {
    event.stopPropagation();
    !disabled && onConfirm?.();
  };

  const handleSelect = () => {
    !disabled && onSelect?.();
  };

  const handleFocus = () => {
    !disabled && onHover?.(true);
  };

  const handleBlur = () => {
    !disabled && onHover?.(false);
  };

  return (
    <div
      className={classNames(
        "cw-border cw-border-solid cw-rounded",
        "cw-px-2 cw-py-1.5",
        "cw-body-base",
        loading || defaultState ? "cw-text-default" : "cw-text-brand",
        loading || defaultState ? "cw-border-subtle" : "cw-border-brand-emphasis",
        disabled
          ? ""
          : selectedState
          ? "hover:cw-border-brand-emphasis-hover"
          : "hover:cw-border-subtle-hover",
        loading || defaultState ? "cw-bg-default" : "cw-bg-brand",
        disabled ? "" : selectedState ? "hover:cw-bg-brand-hover" : "hover:cw-bg-default-hover",
        disabled ? "cw-cursor-default" : "cw-cursor-pointer",
        { "cw-animate-dropShadow-out": emphisis },
      )}
      onClick={handleSelect}
      onMouseEnter={handleFocus}
      onMouseLeave={handleBlur}
      onFocus={handleFocus}
      onBlur={handleBlur}
      role={loading ? "progressbar" : "button"}
      tabIndex={0}
    >
      <div className="cw-w-full cw-flex cw-flex-row cw-items-center cw-justify-between cw-font-normal cw-text-13 cw-leading-6">
        {loading ? (
          <Skeleton variant="text" width="80%" height={24} />
        ) : (
          <>
            <div className="cw-grow cw-text-left cw-font-medium">
              <div className="cw-flex cw-flex-row cw-space-x-1 cw-items-center">
                <div>{text}</div>
              </div>
            </div>
            {defaultState && (
              <div className="cw-flex cw-flex-row cw-space-x-1 cw-items-center cw-caption cw-text-11">
                <div>No conflicts</div>
                <CalendarCheck color={fg_default} size={13} />
              </div>
            )}
            {selectedState && (
              <div className="cw-w-24">
                <Button
                  fullWidth
                  size="mini"
                  variant="solid"
                  sentiment="positive"
                  onClick={handleConfirm}
                >
                  Confirm
                </Button>
              </div>
            )}
            {confirmingState && <div className="cw-font-medium">Rescheduling...</div>}
          </>
        )}
      </div>
    </div>
  );
};
